import { downgradeComponent } from '@angular/upgrade/static';
import { LanguageSwitcherContainerComponent } from '@fry-it/risr-core';

(function() {
  'use strict';

  angular.module('kzHeaderCard')
    .directive('risrLanguageSwitcher', downgradeComponent({
      component: LanguageSwitcherContainerComponent
    }));
})();
